import React, { Suspense } from 'react';
//import { Link } from 'react-router-dom';
//import { withTranslation } from 'react-i18next';
import { userService, genericCodesService, cardsService } from '../_services';
import { InvoicesComponent } from '../InvoicesPage/InvoicesComponent';
import { AppHeader} from '../AppHeader';


class HomePage extends React.Component {
    constructor(props) {
        super(props);

        let card = cardsService.getCardfromSessionStorage();
        let user = userService.getUser(this.props.history);

        this.state = {
            user: user,
            card: card,
            inv_list: '',
            inv_sum: 0,
            inst_name: ''       
        };

        genericCodesService.getGenCode('dd_constants', 'INST_NAME').then((genCodeObj) => {
            console.log(genCodeObj)
            this.setState({ inst_name: genCodeObj.GEN_DESC });
            document.title = this.state.inst_name;
        })

    }

    getSelectedRows = ({ inv_list, inv_sum }) => {
        console.log({ inv_list, inv_sum });
        this.setState({ inv_list, inv_sum });
    }

    // componentDidMount() {
        
    // }

    handleCardChanged = (card) => {
        console.log(card)
        this.setState({
            card: card
        });
    }


    render() {
        const { user } = this.state;
        //const { t } = this.props;
        
        return (
            <Suspense fallback="loading">
                <div className="col-md-8 autoCenter">
                    <AppHeader user={user} onCardChanged={this.handleCardChanged} />                   
                    <div className="col-md-12">
                        <InvoicesComponent getSelectedRows={this.getSelectedRows} card={this.state.card} />
                    </div>
                </div>
            </Suspense>);
    }
}


//const HomePage = withTranslation()(HomePage_)

export { HomePage }; 
